import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CodesReelModel} from '../models/codes-reel.model';

@Injectable({providedIn: 'root'})
export class CodesReelService {
  private http: HttpClient = inject(HttpClient);
  private currentEventSource?: EventSource;

  codesReelStream(): Observable<CodesReelModel[]> {
    return new Observable(observer => {
      const url = `${environment.socketUrl}.well-known/mercure?topic=reel`;
      const eventSource = new EventSource(url);

      this.currentEventSource = eventSource;

      eventSource.onmessage = event => {
        try {
          const data = JSON.parse(event.data);
          if (data?.id) {
            observer.next(data as CodesReelModel[]);
          }
        } catch (error) {
          console.error('Błąd przy parsowaniu danych Mercure:', error);
        }
      };

      eventSource.onerror = error => {
        console.error('Błąd połączenia Mercure:', error);
        try {
          observer.complete();
        } catch {
        }
        try {
          eventSource.close();
        } catch {
        }
        if (this.currentEventSource === eventSource) {
          this.currentEventSource = undefined;
        }
      };

      return () => {
        try {
          eventSource.close();
        } catch {
        }
        if (this.currentEventSource === eventSource) {
          this.currentEventSource = undefined;
        }
      };
    });
  }

  public getCodesReel(): Observable<CodesReelModel[]> {
    return this.http.get<CodesReelModel[]>(`${environment.apiUrl}reel`, {
      withCredentials: true
    });
  }

   public getCodesReelForCategory(categoryId:string): Observable<CodesReelModel[]> {
    return this.http.get<CodesReelModel[]>(`${environment.apiUrl}reel/${categoryId}`, {
      withCredentials: true
    });
  }

  public reserveCode(codeId: string): Observable<void> {
    return this.http.patch<void>(`${environment.apiUrl}code/reservation`, {id: codeId}, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/merge-patch+json',
        'Accept': 'application/json'
      }});
  }
}
